import React, { useRef, useState } from "react"
import { Button, IconButton, Input } from "@material-ui/core"
import { AttachFile } from "@material-ui/icons"
import { makeStyles } from "@material-ui/styles"
import { v4 as uuid } from "uuid"
import Axios from "axios"
import Config from "react-global-configuration"
import { useMutationRegisterUpload } from "../../data"
import { LinkButton } from ".."

const useStyles = makeStyles(() => ({
  fileInput: {
    left: 0,
    bottom: 0,
    width: 1,
    height: 1,
    opacity: 0,
    position: "fixed",
  },
}))

const Uploader = ({
  icon,
  onBeforeUpload,
  onProgress,
  onItemUploaded,
  onAfterUpload,
  onError,
  images = true,
  documents = true,
  multiple = true,
  disabled,
  variant = "icon",
  linkText,
  buttonText,
  buttonProps = {},
  title,
}) => {
  const classes = useStyles()
  const fileRef = useRef(null)
  const [registerUpload] = useMutationRegisterUpload()
  const [uploading, setUploading] = useState(false)
  const { acceptImages, acceptDocuments } = Config.get("uploader")

  const handleClick = () => {
    fileRef.current.click()
  }

  const uploadsToProgress = (uploads) =>
    uploads.filter((u) => u).map(({ upload, order, __upload }) => ({ ...upload, order, __upload }))

  const handleUpload = async (e) => {
    const files = Object.values(e.target.files)
    if (files && files.length > 0) {
      try {
        setUploading(true)
        const uploads = [
          ...files.map((file, index) => ({
            fileName: file.name,
            fileGroup: "upload",
            loaded: 0,
            total: file.size,
            order: index,
            __upload: uuid(),
          })),
        ]
        if (onBeforeUpload) onBeforeUpload([...uploads])

        await Promise.all(
          files.map(async (file, index) => {
            const { data } = await registerUpload({ variables: { fileName: file.name, fileSize: file.size } })
            if (!data) {
              throw Error("Request for upload failed")
            } else {
              const { order, __upload } = uploads[index]
              uploads[index] = { ...data.registerUpload, order, __upload }
              if (onProgress) onProgress(uploadsToProgress(uploads))
            }
          })
        )

        await Promise.all(
          uploads.map(async (upload, index) => {
            try {
              await Axios.put(upload.signedUploadUrl, files[index], {
                headers: {
                  "Content-Type": upload.upload.contentType,
                },
                onUploadProgress: ({ loaded, total }) => {
                  upload.upload.loaded = loaded
                  upload.upload.total = total
                  if (onProgress) onProgress(uploadsToProgress(uploads))
                },
              })
              const { order, __upload } = upload
              if (onItemUploaded) onItemUploaded({ ...upload.upload, order, __upload })
            } catch (errUpload) {
              console.log(errUpload)
              throw errUpload
            }
          })
        )

        if (onAfterUpload) onAfterUpload([...uploads])
      } catch (err) {
        if (onError) onError(err)
      } finally {
        setUploading(false)
      }
    }
  }

  const accept = []
  if (images) accept.push(acceptImages)
  if (documents) accept.push(acceptDocuments)

  return (
    <>
      <Input
        type="file"
        inputRef={fileRef}
        onChange={handleUpload}
        className={classes.fileInput}
        inputProps={{ multiple, accept: accept.join(",") }}
      />
      {variant === "icon" && (
        <IconButton onClick={handleClick} disabled={uploading || disabled} title={title}>
          {icon || <AttachFile />}
        </IconButton>
      )}
      {variant === "link" && (
        <LinkButton onClick={handleClick} disabled={uploading || disabled} title={title}>
          {linkText}
        </LinkButton>
      )}
      {variant === "button" && (
        <Button onClick={handleClick} disabled={uploading || disabled} title={title} {...buttonProps}>
          {buttonText}
        </Button>
      )}
    </>
  )
}

export { Uploader }
